module.exports = __webpack_public_path__ + "19df61da1e04c0e328b9feec45b6fb98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/accenture_2022_chart.png
// module id = 1621
// module chunks = 0